import type { DesktopClient } from "@orni/domain-typescript";
import type { Session } from "../domain";
import { TerminalSurface } from "../components/TerminalSurface";
import type { ProviderTerminalQuickCommand } from "../sdk/types";

export function NativeSessionView({
  client,
  session,
  readOnly = false,
    insertText,
  quickCommands = [],
}: {
  client: DesktopClient;
  session: Session;
  readOnly?: boolean;
  insertText?: { text: string; nonce: number } | null;
  quickCommands?: readonly ProviderTerminalQuickCommand[];
}) {
  return (
    <TerminalSurface
      client={client}
      session={session}
      active
      readOnly={readOnly}
      nativeQuickCommands={quickCommands}
      minimalChrome
      insertText={insertText}
    />
  );
}
